import { render, staticRenderFns } from "./ehc-feedback.vue?vue&type=template&id=0871195b&scoped=true"
import script from "./ehc-feedback.vue?vue&type=script&lang=js"
export * from "./ehc-feedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0871195b",
  null
  
)

export default component.exports